// extracted by mini-css-extract-plugin
module.exports = {"incline_hover":"index__incline_hover--YZnNQ","incline_hovers":"index__incline_hovers--3cwq_","big_incline_hover":"index__big_incline_hover--1hiR8"};